import PropTypes from "prop-types"
import React from "react"

import styled from "styled-components"
import { MfFontIcon } from "../../foundations/FontIcon"

export const StyledItemContainer = styled.li`
  background: none;
  border: 4px solid transparent;
  border-radius: 0;
  color: ${({ theme }) => theme.color.text.darker};
  display: flex;
  min-height: ${({ theme }) => `calc(${theme.spacing(7)} + ${theme.spacing(2)})`};
  justify-content: space-between;
  line-height: unset;
  padding: 0;
  position: relative;
  text-decoration: none;
  width: 100%;

  button {
    &:active,
    &:hover,
    &:focus {
      outline: none;
    }
  }

  ${({ theme }) => theme.media.phone`
    border-left: 4px solid transparent;
  
    &:hover, &:active, &:focus {
      background-color: ${theme.color.hover.light};
    }

    &:focus-within {
      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.05);
    }
  `}

  ${({ theme }) => theme.media.tablet`
    border-left: 4px solid transparent;

    &:hover, &:active, &:focus {
      background: ${theme.color.hover.light};
    }

    &:focus-within {
      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.05);
    }
  `}
`

export const StyledIconsContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: ${({ theme }) => theme.spacing(7)};

  :last-of-type {
    padding-right: ${({ theme }) => theme.spacing(3)};
  }

  :first-of-type {
    padding-left: ${({ theme }) => theme.spacing(2)};
  }

  :first-of-type:not(:last-of-type) {
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`

export const MenuItem = ({
  selected = false,
  cta = undefined,
  children,
  checkSelected = true,
  handleSelect = () => {},
}) => {
  return (
    <StyledItemContainer
      tabIndex={0}
      $cta={cta}
      $selected={selected}
      onMouseOver={(e) => {
        e?.target.focus()
      }}
    >
      {children}
      {selected && checkSelected && (
        <StyledIconsContainer>
          <MfFontIcon
            data-testid="selected-check"
            icon="fonticons-check"
            color="primary:default"
            onClick={handleSelect}
          />
        </StyledIconsContainer>
      )}
    </StyledItemContainer>
  )
}

MenuItem.propTypes = {
  selected: PropTypes.bool,
  cta: PropTypes.elementType,
  checkSelected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  handleSelect: PropTypes.func,
}
